import * as React from "react";
import "./index.css";
import ModalBase from "../../ModalBase";
import { OutlinedInput } from "../../../Input";
import { CallIcon, MailIcon, WhatsappOutlineIcon } from "../../../icons";
import Button from "../../../Button";

const ContactInfoModal = ({  onClose }) => {
  const [formState, setFormState] = React.useState({
    mail: "",
    number: "",
    whatsapp: "",
  });

  const handleInputChange = (e) =>
    setFormState({ ...formState, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(formState);
    setFormState({ mail: "", number: "", whatsapp: "" });
  };

  const [fromTop, setFromTop] = React.useState("50%");

  React.useEffect(() => {
    const handlePosition = () => {
      const isMobile = window.innerWidth <= 768;
      setFromTop(isMobile ? "30%" : undefined);
    };

    handlePosition();

    window.addEventListener("resize", handlePosition);

    return () => window.removeEventListener("resize", handlePosition);
  }, []);

  return (
    <ModalBase
      onClose={onClose}
      className={"contact-info-modal"}
      title={"Contact Information"}
    >
      <form className="contact-info-modal-base" onSubmit={onSubmit}>
        <span className="modal-title">
          Contact Information
        </span>
        <OutlinedInput
          style={{
            color: "rgba(61, 59, 64, 1)",
            fontWeight: "600",
          }}
          leading={<MailIcon className={"menu-icon"} fill="rgba(0, 0, 0, 0)" />}
          className={"contact-info-input"}
          placeholder={"abc@example.com"}
          value={formState.mail}
          name={"mail"}
          title={"Email"}
          type={"email"}
          onChange={handleInputChange}
        />
        <OutlinedInput
          style={{
            color: "rgba(61, 59, 64, 1)",
            fontWeight: "600",
          }}
          leading={<CallIcon className={"menu-icon"} fill="rgba(0, 0, 0, 0)" />}
          className={"contact-info-input"}
          placeholder={"(000) 111-2222"}
          value={formState.number}
          name={"number"}
          title={"Phone number"}
          type={"number"}
          onChange={handleInputChange}
        />
        <OutlinedInput
          style={{
            color: "rgba(61, 59, 64, 1)",
            fontWeight: "600",
          }}
          type={"number"}
          leading={
            <WhatsappOutlineIcon
              className={"menu-icon"}
              fill="rgba(0, 0, 0, 0)"
            />
          }
          className={"contact-info-input"}
          placeholder={"(000) 111-2222"}
          value={formState.whatsapp}
          name={"whatsapp"}
          title={"WhatsApp"}
          onChange={handleInputChange}
        />
        <div className={"contact-info-submit-btn"} type={"submit"}>
          Save Changes
        </div>
      </form>
    </ModalBase>
  );
};

export default ContactInfoModal;
